import useMediaQuery from "@mui/material/useMediaQuery";

const useIsMobile = (breakpoint = 900) => {
  return useMediaQuery(`(max-width:${breakpoint}px)`);
};

export default useIsMobile;
